import { NavLink } from "react-router-dom";
import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";

const MenuItem = styled.li`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 ${({ theme }) => theme.layout.header.menu.secondaryMenuSpacing}
  };
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.opal};
  a {
    user-select: none;
  }
}
`;

const menuItems = [
  { link: "/privacy", label: "header.footerMenu.privacy" },
  { link: "/terms", label: "header.footerMenu.terms" },
];

const FooterMenu = () => {
  const { t } = useTranslation();

  return (
    <ul>
      {menuItems.map((item, key) => (
        <MenuItem key={key}>
          <NavLink to={item.link} key={key}>
            {t(item.label)}
          </NavLink>
        </MenuItem>
      ))}
    </ul>
  );
};

export default FooterMenu;
